import { Recipient } from '@adornis/mails/db/recipients.js';
import { config } from '@ils/config/config.js';
import { domainWhiteList, enableMail } from './server/mailer.js';

export const AccountingRecipient = () => {
  return enableMail
    ? new Recipient(config.get('ACCOUNTINGMAIL'))
    : new Recipient('info@adornis.de', 'famed@adornis.de');
};

export const ilsRecipients = (userMail: string, additionalBCCMails?: string[]) =>
  enableMail
    ? // --> cc info@, bcc instruct is intentional
      new Recipient(userMail, config.get('TECHNICALSUPPORTMAIL'), [
        config.get('ACCOUNTINGMAIL'),
        ...(additionalBCCMails ?? []),
      ])
    : new Recipient(
        domainWhiteList.some(domain => userMail.endsWith(`@${domain}`))
          ? userMail
          : userMail.replace('@', '__') + '@adornis.de',
      );
